import * as React from "react";

import { SignInButton } from "../utils/SignInButton";

const Splash = () => {
    const maxSize = screen?.width > 800 ? "200px" : "100%";
    const logoMaxSize = screen?.width > 600 ? "200px" : "100%";

    return (
        <div className="flex items-center justify-center min-h-screen w-full">
            <div className="bg-background-front p-4 rounded-md shadow-sm">
                <img
                    src="/images/logo.png"
                    alt="Logo"
                    className="m-2"
                    style={{ width: logoMaxSize, maxWidth: "200px", objectFit: "contain" }}
                />
                <p className="text-lg text-text text-center">Separator Solutions</p>
                <div className="mt-4 mb-2 flex justify-center">
                    <SignInButton />
                </div>
            </div>
        </div>
    );
};

export default Splash;
